import history from '../history';
import * as AppJump from '../core/app-jump';
import { loading } from './ui-core.actions';
import { putContext } from './contexts.action';
import {
  authenticationContext,
  uiActions,
  objectUtils
} from '@codametrix/ui-common';

export const jumpURL = async (ctx: CMx.Context, dispatch: any) => {
  const { contexts } = ctx;
  const isSingleContext = contexts.length === 1;
  const hasMultipleContexts = contexts.length > 1;
  // after a successful login we check to see if the user has a jump url specified.
  const jumpInfo = AppJump.getJump();
  const hasJump = jumpInfo && objectUtils.isString(jumpInfo.url);
  let jumped = false;
  const jump = () => {
    if (hasJump) {
      history.replace(jumpInfo.url);
    }
    dispatch(loading(false));
    jumped = true;
  };

  const selectContext = () => {
    dispatch(loading(false));
    dispatch(uiActions.chooseContext(ctx));
  };

  const isColdBootJump = hasJump && jumpInfo.contextId === 0;

  if (isSingleContext) {
    const containsContext = contexts.find(ctx => {
      return ctx.organizationId === jumpInfo.contextId;
    });

    if (containsContext) {
      // work around.  there's an issue with the activeContextId.
      if (ctx.activeContextId !== jumpInfo.contextId) {
        const jumpChoice = {
          organizationId: `${jumpInfo.contextId}`,
          token: `${authenticationContext.getToken()}`
        };
        await putContext(jumpChoice, dispatch);
      } else {
        // the user may be a different user than the one who
        // originally logged in.  if this is the case, do not jump.
        selectContext();
      }
      jump();
    } else if (isColdBootJump) {
      jump();
    }
  } else if (hasMultipleContexts) {
    if (isColdBootJump) {
      jump();
    }
  } else {
    selectContext();
    jump();
  }
  return jumped;
};
